import { Wrench } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

// Página de mantenimiento (kill switch). Sin botones de acción — el usuario
// no puede hacer nada hasta que el equipo levante el sistema.
export const MaintenancePage = () => {
  return (
    <div className="bg-bg flex min-h-screen items-center justify-center p-6">
      <Card className="w-full max-w-md text-center">
        <CardHeader className="items-center gap-2">
          <div
            className="bg-surface-2 flex h-16 w-16 items-center justify-center rounded-full"
            aria-hidden="true"
          >
            <Wrench className="text-info h-8 w-8" />
          </div>
          <CardTitle className="text-2xl">En mantenimiento</CardTitle>
          <CardDescription>Estamos haciendo mantenimiento. Vuelve en un rato.</CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-text-muted text-sm">
            Si necesitas soporte urgente, contacta al equipo interno.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};
